if (!customElements.get('product-title-fit')) {
  customElements.define(
    'product-title-fit',
    class ProductTitleFit extends HTMLElement {
      connectedCallback() {
        this.titleElement = this.querySelector('h1');
        if (!this.titleElement) return;

        this.resizeObserver = new ResizeObserver((entries) => {
          const width = Math.round(entries[0].contentRect.width);
          if (width === this.lastWidth) return;

          this.lastWidth = width;
          this.requestFit();
        });
        this.resizeObserver.observe(this);
        this.requestFit();

        if (document.fonts?.ready) {
          document.fonts.ready.then(() => this.requestFit());
        }
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.fitFrame);
      }

      requestFit() {
        cancelAnimationFrame(this.fitFrame);
        this.fitFrame = requestAnimationFrame(() => this.fitTitle());
      }

      fitTitle() {
        const title = this.titleElement;
        const availableWidth = this.clientWidth;
        if (!title || availableWidth <= 0) return;

        title.style.removeProperty('font-size');
        this.classList.remove('is-fitting');
        this.classList.remove('is-clamped');

        const preferredFontSize = Number.parseFloat(getComputedStyle(title).fontSize);
        if (this.fitsInTwoLines(title)) return;

        this.classList.add('is-fitting');

        const minimumFontSize = Math.min(18, preferredFontSize);
        let smallestFit = minimumFontSize;
        let largestFit = preferredFontSize;

        for (let step = 0; step < 10; step += 1) {
          const candidate = (smallestFit + largestFit) / 2;
          title.style.fontSize = `${candidate}px`;

          if (this.fitsInTwoLines(title)) {
            smallestFit = candidate;
          } else {
            largestFit = candidate;
          }
        }

        title.style.fontSize = `${smallestFit}px`;

        if (!this.fitsInTwoLines(title)) {
          this.classList.add('is-clamped');
        }
      }

      fitsInTwoLines(title) {
        const computedStyle = getComputedStyle(title);
        const lineHeight = Number.parseFloat(computedStyle.lineHeight);
        const maximumHeight = lineHeight * 2 + 1;

        return title.getBoundingClientRect().height <= maximumHeight;
      }
    }
  );
}
